// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","blocklistToggleModalLink":"_21u0OTH06PqeVxMu0q67dL"};